import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import {
  DocumentViewer,
  extension,
  canPreview,
  canConvert,
} from 'components/visual/documentViewer';

import { fetchAsset } from '../actions';

export { canPreview, canConvert };

export const AssetViewerComponent = (props) => {
  const {
    asset,
    modal,
    renderer,
    onClose,
    handleFetchAsset,
    enableZoom,
    enableDownload,
    loadingComponent,
  } = props;
  const [newAsset, setAsset] = useState(asset);
  const onError = () =>
    handleFetchAsset(asset)
      .then(setAsset)
      .catch(() => {});
  const cachedAsset = sessionStorage.getItem(`asset:${asset.id}`);
  const useAsset =
    (canPreview(newAsset.url) && newAsset) ||
    (cachedAsset && JSON.parse(cachedAsset)) ||
    newAsset;

  useEffect(() => {
    if (canConvert(extension(asset.url))) {
      const timer = setInterval(() => {
        handleFetchAsset(asset)
          .then((response) => {
            if (!canConvert(extension(response.url))) {
              setAsset(response);
              sessionStorage.setItem(
                `asset:${asset.id}`,
                JSON.stringify(response)
              );
              clearInterval(timer);
            }
          })
          .catch(() => clearInterval(timer));
      }, 10000);

      return () => clearInterval(timer);
    }

    if (canPreview(asset.url)) {
      setAsset(asset);
      sessionStorage.setItem(`asset:${asset.id}`, JSON.stringify(asset));
    }

    return null;
  }, [asset]);

  return (
    <DocumentViewer
      url={useAsset.url}
      downloadUrl={useAsset.original_url}
      renderer={renderer}
      modal={modal}
      onError={onError}
      onClose={onClose}
      enableZoom={enableZoom}
      enableDownload={enableDownload}
      loadingComponent={loadingComponent}
    />
  );
};

AssetViewerComponent.propTypes = {
  asset: PropTypes.shape({
    id: PropTypes.string,
    filename: PropTypes.string,
    url: PropTypes.string,
    original_url: PropTypes.string,
    read_token: PropTypes.string,
  }),
  renderer: PropTypes.shape({
    withScrollbars: PropTypes.bool,
    withBorder: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  loadingComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  modal: PropTypes.bool,
  onClose: PropTypes.func,
  handleFetchAsset: PropTypes.func,
  enableZoom: PropTypes.bool,
  enableDownload: PropTypes.bool,
};

AssetViewerComponent.defaultProps = {
  modal: true,
  renderer: {
    withScrollbars: true,
    withBorder: false,
  },
  enableDownload: true,
};

function mapDispatchToProps(dispatch) {
  return {
    handleFetchAsset: (asset) => dispatch(fetchAsset(asset)),
  };
}

const withConnect = connect(null, mapDispatchToProps);

export const AssetViewer = compose(withConnect)(AssetViewerComponent);
